import { getFileExtension, getMimeType } from "utils/helpers";
import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';

interface FileIconProps {
  downloadIcon: boolean;
  filePath: string;
  fileName: string;
  companyId: string;
  getDownloadResources(filePath: string, companyId: string): any;
}

const FileIcon = (props: FileIconProps) => {
  //Note: This api downloads specifically for the Resources page
  const downloadFile = (filePath: string, openTab: boolean, companyId: string) => {
    props.getDownloadResources(filePath, companyId)
      .then((response: string) => {
        const mimeType = getMimeType(filePath);
        let blob = new Blob([response], { type: mimeType });
        if (!openTab) {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = props.fileName;
          link.click();
        } else {
          window.open(URL.createObjectURL(blob), "_blank", "");
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  return (
    <>
      {props.downloadIcon ? <i className="neutral fa fa-solid fa-download mr-1" onClick={() => downloadFile(props.filePath, false, props.companyId)}></i> : null}
      {getFileExtension(props.fileName) === 'pdf' ? <i className="dust-red-6 fa fa-solid fa-file-csv" onClick={() => downloadFile(props.filePath, true, props.companyId)}></i> : null}
      {getFileExtension(props.fileName) === 'csv' ? <i className="lime-6 fa fa-solid fa-file-csv" onClick={() => downloadFile(props.filePath, true, props.companyId)}></i> : null}
      {['doc', 'docx'].includes(getFileExtension(props.fileName?.toLowerCase())) ? <i className="primary-7 fa fa-solid fa-file-word" onClick={() => downloadFile(props.filePath, true, props.companyId)}></i> : null}
      {['xls', 'xlsx'].includes(getFileExtension(props.fileName?.toLowerCase()))? <i className="polar-green-6 fa fa-solid fa-file-excel" onClick={() => downloadFile(props.filePath, true, props.companyId)}></i> : null}
      {!['csv','doc', 'docx', 'xls', 'xlsx', 'pdf'].includes(getFileExtension(props.fileName?.toLowerCase())) ? <i className="neutral fa fa-solid fa-file" onClick={() => downloadFile(props.filePath, true, props.companyId)}></i> : null}
    </>
  )
}

export default FileIcon;